module.exports = __webpack_public_path__ + "img/down.520dc215.png";